import { functions } from "./firebase";
import { httpsCallable } from "firebase/functions";

export const retreiveQuote = httpsCallable(functions, "retreiveQuote");
export const quoteOpenedNotificaiton = httpsCallable(functions, "quoteOpened");
